import React from 'react';

export default ({
  inStock,
}) => (
  <React.Fragment>
    På fjernlager. Bestil mindst {Math.abs(inStock)} dage før brug.
  </React.Fragment>
);
